import React, { Component, Fragment } from "react";
import { Card, CardBody, Button, FormGroup, Label, } from "reactstrap";
import Select from "react-select";
import Slider from "rc-slider"
import { Check } from "react-feather";
import Radio from "../../theme/@vuexy/radio/RadioVuexy";
import Checkbox from "../../theme/@vuexy/checkbox/CheckboxesVuexy";
import "rc-slider/assets/index.css"

import "../../assets/scss/plugins/extensions/slider.scss"

const createSliderWithTooltip = Slider.createSliderWithTooltip
const Range = createSliderWithTooltip(Slider.Range)

const TYPE = ["Dummy 1", "Dummy 2", "Dummy 3", "Dummy 4", "Dummy 5", "Dummy 6"];
const CATEGORY = ["Category 1", "Category 2", "Category 3", "Category 4", "Category 5", "Category 6"];
const TIMELINE = ["Today", "Yesterday", "7 Days", "15 Days", "30 Days"];
const EVENT = ["Attended", "Shared", "Visited", "Invite"];

const custOptions = [
  { value: 0, label: "Akash Dua" },
  { value: 1, label: "John Doe" },
  { value: 2, label: "Marie J" },
  { value: 3, label: "Anand" },
]

const marks = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5'
}

class FiltersSection extends Component {

  state = {
    event: "",
    timeline: [],
    stage: [],
    is_shareable: false
  };

  handleRadio = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleSlider = value => {
    this.setState({
      stage: value
    })
  }

  setCustomer = o => {
    this.setState({
      custValue: o.value
    })
  }

  handleCheckbox = value => {
    let { timeline } = this.state;
    let status = timeline.includes(value);
    if (!status) {
      timeline.push(value);
    } else {
      let index = timeline.indexOf(value);
      if (index > -1) {
        timeline.splice(index, 1);
      }
    }
    this.setState({ timeline })
  }

  render() {
    return (
      <Fragment>
        <h6 className="filter-heading d-none d-lg-block">Filters</h6>
        <Card className="mt-2">
          <CardBody className="p-2">
            <div className="brands">
              <div className="brand-title mt-1 pb-1">
                <h6 className="filter-title mb-0">Timeline</h6>
              </div>
              <div className="brand-list">
                <ul className="list-unstyled brand-list">
                  <li className="py-25">
                    <Radio
                      label="All"
                      defaultChecked={true}
                      name="event"
                      value=""
                      disabled={this.state.event === "" ? true : false}
                      onClick={this.handleRadio}
                    />
                  </li>
                  {
                    TIMELINE.map((item, index) => {
                      return (
                        <li className="py-25" key={index}>
                          <Radio
                            label={item}
                            defaultChecked={false}
                            disabled={this.state.event === `${item}` ? true : false}
                            name="event"
                            value={item}
                            onClick={this.handleRadio}
                          />
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            </div>
            <hr />
            <div className="multi-range-price">
              <div className="multi-range-title pb-75">
                <h6 className="filter-title mb-0">Activity</h6>
              </div>
              <ul className="list-unstyled price-range">
                {
                  EVENT.map((item, index) => {
                    return (
                      <li className="py-25" key={index}>
                        <Checkbox
                          color="primary"
                          name="timeline"
                          icon={<Check className="vx-icon" size={16} />}
                          label={item}
                          onClick={() => { this.handleCheckbox(`${item}`) }}
                          defaultChecked={false}
                        />
                      </li>
                    );
                  })
                }
              </ul>
            </div>
            <hr />
            <div className="price-slider">
              <div className="price-slider-title mt-1">
                <h6 className="filter-title mb-0">Customer Rating</h6>
              </div>
              <div className="price-slider mt-1">
                <Range
                  min={1}
                  max={5}
                  marks={marks}
                  defaultValue={[1, 5]}
                  tipFormatter={value => `${value}`}
                />
              </div>
            </div>
            <br />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}

export default FiltersSection;